import { render, staticRenderFns } from "./ruralVitalization.vue?vue&type=template&id=109d8e74&scoped=true&"
import script from "./ruralVitalization.vue?vue&type=script&lang=js&"
export * from "./ruralVitalization.vue?vue&type=script&lang=js&"
import style0 from "./ruralVitalization.vue?vue&type=style&index=0&id=109d8e74&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109d8e74",
  null
  
)

export default component.exports